'use client';

import { c as _c } from "react/compiler-runtime";
import { useAtom, useAtomValue } from 'jotai';
import { BsFillGridFill } from 'react-icons/bs';
import { FaList, FaMapLocationDot } from 'react-icons/fa6';
import { isMapViewAtom } from '@/features/listing/atoms/is-map-view-atom';
import { listingsViewAtom } from '@/features/listing/atoms/listings-view-atom';
import styles from './map-view-switch.module.scss';
export default function MapViewSwitch() {
  const $ = _c(9);
  const [isMapView, setIsMapView] = useAtom(isMapViewAtom);
  const listingsView = useAtomValue(listingsViewAtom);
  let t0;
  if ($[0] !== isMapView || $[1] !== setIsMapView) {
    t0 = () => {
      setIsMapView(!isMapView);
    };
    $[0] = isMapView;
    $[1] = setIsMapView;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const handleMapViewChange = t0;
  let t1;
  if ($[3] !== isMapView || $[4] !== listingsView) {
    t1 = isMapView ? <>{listingsView === "list" ? <FaList className={styles.mapViewSwitch_mapIcon} /> : <BsFillGridFill className={styles.mapViewSwitch_mapIcon} />}</> : <FaMapLocationDot className={styles.mapViewSwitch_mapIcon} />;
    $[3] = isMapView;
    $[4] = listingsView;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== handleMapViewChange || $[7] !== t1) {
    t2 = <button className={styles.mapViewSwitch} aria-label="map view switch" onClick={handleMapViewChange}>{t1}</button>;
    $[6] = handleMapViewChange;
    $[7] = t1;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
}